import { render } from "./service.vue?vue&type=template&id=188748bb&scoped=true&ts=true"
import script from "./service.vue?vue&type=script&lang=ts"
export * from "./service.vue?vue&type=script&lang=ts"

import "./service.vue?vue&type=style&index=0&id=188748bb&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188748bb"]])

export default __exports__